import * as z from "zod";
import { cursorPageOf, cursorPagination } from "../index";
import { suppressionKinds } from "./enums";

// The addresses that asked for no email (`platform.email_suppression`, ADR-087 point 7, ADR-149 point 8): a row to
// one of them is written `suppressed` and never sent.

export const emailSuppressionDto = z
  .object({
    id: z.uuid(),
    email: z.string(),
    kind: z.enum(suppressionKinds),
    reason: z.string().nullable(),
    createdAt: z.iso.datetime(),
    createdBy: z.string().nullable(),
  })
  .meta({ id: "EmailSuppression" });

export const emailSuppressionPageDto = cursorPageOf(emailSuppressionDto).meta({ id: "EmailSuppressionPage" });

/** The latest added first. */
export const listEmailSuppressionsInput = z.object({
  /** Part of the address, in any case. */
  q: z.string().trim().min(1).max(320).optional(),
  ...cursorPagination({ defaultLimit: 50, maxLimit: 200 }),
});
export type ListEmailSuppressionsInput = z.input<typeof listEmailSuppressionsInput>;

export const addEmailSuppressionInput = z.object({
  email: z.email().max(320),
  reason: z.string().trim().min(1).max(500),
});
export type AddEmailSuppressionInput = z.input<typeof addEmailSuppressionInput>;

export const removeEmailSuppressionInput = z.object({ suppressionId: z.uuid() });
export type RemoveEmailSuppressionInput = z.input<typeof removeEmailSuppressionInput>;

export const removedEmailSuppressionDto = z.object({ id: z.uuid(), email: z.string() });
